<template>
  <div class="networkSearch">
    <!-- section start -->
    <section>
      <div class="inner row3_1 flex mobileFlexCol">
        <article class="wd100">
          <h1 class="mainTitle">
            네트워킹 검색
          </h1>

          <NetworkSearchFilter />
          <h5 class="networkSearch__headline">총 2544개 기업</h5>
          <div class="networkSearchList">
            <div
              class="networkSearchItem"
              v-for="item in items"
              :key="item"
              @click="handleToggleModal"
            >
              <figure class="networkSearchItemImage">
                <img src="/images/manager/matching/demo1.png" alt="미국 국기" />
              </figure>
              <div
                class="networkSearchItemText"
                style="background-color: #F6F6F6;"
              >
                <h3 class="networkSearchItemTitle" style="color: #502423;">
                  이 순 신
                  <span class="networkSearchItem__status">연구자</span>
                </h3>
                <h5 class="networkSearchItemDesc" style="color: #502423;">
                  고령친화 의료기기 산업
                </h5>
                <div style="text-align: center; padding-top: 32px;">
                  <button class="networkSearchItemButton">
                    프로필 보기
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <PaginationMatching />
          </div>
        </article>
      </div>
    </section>

    <PopUpViewProfile
      :isShowModal="isShowModal"
      :handleToggleModal="handleToggleModal"
    />
  </div>
</template>

<script>
import NetworkSearchFilter from "./NetworkSearchFilter.vue";
import PaginationMatching from "@/components/general/PaginationMatching.vue";
import PopUpViewProfile from "./PopUpViewProfile.vue";

export default {
  name: "NetworkSearchPage",
  components: { NetworkSearchFilter, PaginationMatching, PopUpViewProfile },
  data() {
    return {
      isShowModal: false,
      items: Array.from({ length: 12 }, (_, index) => index + 1),
    };
  },
  methods: {
    handleToggleModal() {
      this.isShowModal = !this.isShowModal;
    },
  },
};
</script>

<style scoped lang="scss">
.networkSearch {
  .mainTitle {
    &::after {
      display: none !important;
    }
  }
}
</style>
